import type { ReactNode } from 'react';
import { UserAvatar } from '@clarix/ui-shared';

interface IdentityCardProps {
  name: string;
  email?: string | null;
  /** Designation / department line under the name. */
  subtitle?: string;
  /** Render the email as a `mailto:` link (colleague view). */
  emailAsLink?: boolean;
  /** Badges shown under the subtitle. */
  badges?: ReactNode;
  /** Trailing action, e.g. Sign Out. */
  action?: ReactNode;
}

export function IdentityCard({
  name,
  email,
  subtitle,
  emailAsLink = false,
  badges,
  action,
}: IdentityCardProps) {
  return (
    <section className="border-border bg-background flex flex-col items-center gap-3 rounded-xl border p-5 text-center">
      <UserAvatar name={name} className="h-20 w-20" fallbackClassName="text-3xl" />
      <div className="w-full min-w-0">
        <h1 className="text-foreground break-words text-4xl font-semibold">{name}</h1>
        {subtitle && <p className="text-foreground truncate text-xl">{subtitle}</p>}
        {email &&
          (emailAsLink ? (
            <a
              href={`mailto:${email}`}
              title={email}
              className="text-primary block truncate text-xl hover:underline focus-visible:underline"
            >
              {email}
            </a>
          ) : (
            <p className="text-muted-foreground truncate text-xl" title={email}>
              {email}
            </p>
          ))}
      </div>
      {badges && <div className="flex flex-wrap items-center justify-center gap-1.5">{badges}</div>}
      {action}
    </section>
  );
}
